import { render } from "./Inschrijven.vue?vue&type=template&id=e3797950&scoped=true"
import script from "./Inschrijven.vue?vue&type=script&lang=js"
export * from "./Inschrijven.vue?vue&type=script&lang=js"

import "./Inschrijven.vue?vue&type=style&index=0&id=e3797950&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3797950"]])

export default __exports__